<template>
  <router-link
    :to="{ name: item.name }"
    :target="item.target"
    class="subitem-text"
  >
    {{ $t(item.text) }}
  </router-link>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.subitem-text {
  display: flex;
  color: $color-text-light;
  cursor: pointer;
  font-weight: 400;
  width: 100%;
  padding: $spacing-5xs 0 $spacing-5xs $spacing-4xs;
  border-radius: $border-radius-s;

  &:hover {
    background: $color-paper;
  }

  &.router-link-active {
    color: $color-text;
    font-weight: 700;
  }

  &:hover {
    color: $color-text;
  }
}
</style>
